<template>
  <div>
    <component-header
      title="View User"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/user')"
    />
    <div>
      <b-row class="mt-1">
        <b-col cols="12" md="3" class="mb-3 mb-md-0">
          <profileCard
            :imageUrl="userData.profilePhoto"
            :name="`${userData.name.first} ${userData.name.last}`"
            :email="userData.authentication.email"
            :phone="userData.authentication.phone"
          >
            <div class="d-flex justify-conent-center">
              <b-button
                size="sm"
                class="mr-2 my -0 main-navigation-button mx-3"
                variant="primary"
                v-b-modal.modal-1
                @click="kycByUser"
              >
                KYC Details
              </b-button>
            </div>
          </profileCard>
        </b-col>
        <b-col cols="12" md="9">
          <!-- organisation card -->
          <b-card class="user-info-card">
            <b-row class="px-2 d-flex align-items-center">
              <b-col md="4">
                <h3>User Information</h3>
              </b-col>
            </b-row>
            <b-row class="px-2 mt-1">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">First Name :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.name ? userData.name.first : "" }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col class="border-left-dashed" md="5">
                    <p class="left-text">Last Name :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.name ? userData.name.last : "" }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              class="m-2 border-bottom-dashed"
            ></b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">Phone Number:</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.authentication.phone }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col class="border-left-dashed" md="5">
                    <p class="left-text">Email :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.authentication.email }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              class="m-2 border-bottom-dashed"
            ></b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">Gender :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.gender }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col class="border-left-dashed" md="5">
                    <p class="left-text">Marital Status :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.maritalStatus }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              class="m-2 border-bottom-dashed"
            ></b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">Education :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.education }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col class="border-left-dashed" md="5">
                    <p class="left-text">DOB :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ userData.dob }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>

          <!--org card end-->

          <!-- card2 starts -->
          <div>
            <b-card class="user-info-card">
              <b-row class="px-2 d-flex align-items-center">
                <b-col md="4">
                  <h3>User Address</h3>
                </b-col>
              </b-row>
              <b-row class="px-2 mt-1">
                <b-col>
                  <b-row>
                    <b-col md="5">
                      <p class="left-text">City :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.address.city }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col class="border-left-dashed" md="5">
                      <p class="left-text">State :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.address.state }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row
                class="border-bottom-dashed m-2"
              ></b-row>
              <b-row class="px-2">
                <b-col>
                  <b-row>
                    <b-col md="5">
                      <p class="left-text">Country :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.address.country }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col class="border-left-dashed" md="5">
                      <p class="left-text">Zipcode :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.address.zip }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <!-- card2 ending -->

          <!-- card3 starting -->
          <div>
            <b-card class="user-info-card">
              <b-row class="px-2 d-flex align-items-center">
                <b-col md="4">
                  <h3>User Access</h3>
                </b-col>
              </b-row>
              <b-row class="px-2 mt-1">
                <b-col>
                  <b-row>
                    <b-col md="5">
                      <p class="left-text">User Name :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.authentication.userName }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col class="border-left-dashed" md="5">
                      <p class="left-text">Category :</p>
                    </b-col>
                    <b-col md="7">
                      <p class="right-text">
                        {{ userData.category }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row
                class="border-bottom-dashed m-2"
              ></b-row>
              <b-row class="px-2">
                <b-col>
                  <b-row>
                    <b-col md="2" class="mr-4">
                      <p class="left-text">Access Level :</p>
                    </b-col>
                    <b-col md="7" class="ml-1">
                      <p class="right-text">
                        {{ userData.authorization.orgAccess.orgAccessLevel }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <!-- card3 ending -->

          <!-- card4 starting -->
          <div>
            <b-card class="user-info-card">
              <b-row class="px-2 d-flex align-items-center">
                <b-col md="4">
                  <h3>Other Information</h3>
                </b-col>
              </b-row>
              <b-row class="px-2 mt-1">
                <b-col>
                  <b-row>
                    <b-col md="2" class="mr-4">
                      <p class="left-text">About Me :</p>
                    </b-col>
                    <b-col md="7" class="ml-1">
                      <p class="right-text">
                        {{ userData.aboutMe }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <!-- card4 ending -->
          <div>
            <b-card class="user-info-card">
              <b-row class="px-2 d-flex align-items-center">
                <b-col md="4">
                  <h3>Additional Information</h3>
                </b-col>
              </b-row>
              <b-row class="p-2"
                ><div class="mb-3 text-center w-100 py-3" v-if="Object.keys(extendedData).length == 0">
                  No Data Available
                </div>
                <b-col
                  md="6"
                  v-for="([key, value], index) in Object.entries(extendedData)"
                  :key="index"
                  class="line-bottom"
                >
                  <b-row class="px-2 py-2" :class="{ line: index % 2 == 1 }">
                    <b-col md="6">
                      <p class="left-text">{{ camelCaseToTitleCase(key) }} :</p>
                    </b-col>
                    <b-col md="6">
                      <p class="right-text">
                        {{ formatString(value) }}
                      </p>
                    </b-col> </b-row
                  ><b-col class="line"> </b-col>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      id="modal-1"
      scrollable
      ref="modal1"
      title="KYC Details"
      size="lg"
      centered
      hide-footer
    >
      <div>
        <b-row v-if="isloading">
          <b-col md="12" class="text-center loading-container">
            <atom-spinner :animation-duration="1000" :size="60" color="#ff1d5e" class="my-4" />
          </b-col>
        </b-row>
        <b-row
          class="px-5 py-2"
          v-else-if="kycUser && kycUser.documents && kycUser.documents.length"
        >
          <b-col
            md="8"
            lg="12"
            class="justify-content-center"
            :key="i"
            v-for="(kyc, i) in kycUser.documents"
          >
            <b-row>
              <h5 class="h5-text">
                {{ kyc.docType }} :
                <span class="span-text">{{ kyc.documentNo }}</span>
              </h5>
            </b-row>
            <b-row>
              <h5 class="h5-text">
                Document Type :
                <span class="span-text">{{ kyc.docType }}</span>
              </h5>
            </b-row>
            <b-row>
              <h5 class="h5-text">Photo :</h5>
            </b-row>
            <b-row>
              <b-col md="6">
                <a target="_blank" :href="kyc.frontSideFilePath">
                  <img
                    :src="kyc.frontSideFilePath"
                    height="200px"
                    width="300px"
                    class="border-img-doc"
                  />
                </a>
                <label>Front Side</label>
              </b-col>
              <b-col md="6">
                <a target="_blank" :href="kyc.backSideFilePath">
                  <img
                    :src="kyc.backSideFilePath"
                    height="200px"
                    width="300px"
                    class="border-img-doc"
                  />
                </a>
                <label>Back Side</label>
              </b-col>
            </b-row>
            <hr />
          </b-col>
          <div class="w-100 d-flex justify-content-center">
            <b-button
              v-if="
                userData &&
                userData.meta &&
                userData.meta.kycStatus !== 'ACTIVE' &&
                userData &&
                userData.meta &&
                userData.meta.kycStatus !== 'REJECTED' &&
                !approved &&
                !rejected
              "
              variant="success"
              class="mx-2"
              @click="approve"
            >
              Approve
            </b-button>
            <b-button
              v-if="
                userData &&
                userData.meta &&
                userData.meta.kycStatus !== 'ACTIVE' &&
                userData &&
                userData.meta &&
                userData.meta.kycStatus !== 'REJECTED' &&
                !approved &&
                !rejected
              "
              variant="danger"
              class="mx-2"
              @click="reject"
            >
              Reject
            </b-button>
            <b-button
              v-if="
                (userData &&
                  userData.meta &&
                  userData.meta.kycStatus === 'ACTIVE') ||
                approved
              "
              variant="success"
              disabled
            >
              Approved
            </b-button>
            <b-button
              v-if="
                (userData &&
                  userData.meta &&
                  userData.meta.kycStatus === 'REJECTED') ||
                rejected
              "
              variant="danger"
              disabled
            >
              Rejected
            </b-button>
          </div>
        </b-row>
        <b-row v-else>
          <b-col md="12" class="text-center">
            <h3 class="text-primary-custom">Kyc Data Not Found</h3>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";
import ebButton from "@/components/FormElements/Button";
import profileCard from "@/components/Generics/profileCard.vue";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "Viewuser",
  components: {
    cInput,
    ebButton,
    cTelInput,
    ComponentHeader,
    ebSelect,
    profileCard,
    AtomSpinner,
  },
  data() {
    return {
      isloading: false,
      selectedStatus: "",
      approved: false,
      rejected: false,
    };
  },
  computed: {
    // ...mapState("ViewUser", ["userData"]),
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
      userData: "tenant/GetUserDataDetail",
    }),
    ...mapState({
      extendedData: (state) => state.tenant.extendedData,
    }),
  },

  methods: {
    formatString(dateString) {
      const datePattern = /\d{1,2}[/-]\d{1,2}[/-]\d{2,4}/; // Adjust the regex based on expected date formats
      if (typeof dateString === "string" && datePattern.test(dateString)) {
        const date = moment(dateString);

        if (date.isValid()) {
          // Render the date in a desired format, e.g., 'MMMM Do YYYY'
          return date.format("MMMM Do YYYY");
        }
      }
      return dateString; // Return original if not a valid date string
    },

    camelCaseToTitleCase(camelCaseString) {
      const titleCaseString = camelCaseString
        .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
        .replace(/_/g, " "); // Replace underscores with spaces

      return titleCaseString
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    changeStatus() {
      this.updateStatus();
    },
    async viewManagemtDetail() {
      await this.$store
        .dispatch("tenant/viewUserManagementDetail", this.$route.params.userId)
        .then((res) => {
          set: {
            this.userData = res;
          }
        });
    },
    async updateStatus() {
      this.isloading = true;
      try {
        await this.$store.dispatch("tenant/updateStatus", {
          id: this.userData._id,
          data: {
            status: this.selectedStatus,
          },
        });
      } catch (err) {}
      this.isloading = false;
    },
    async kycByUser() {
      this.isloading = true;
      const data = await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this.userData._id,
        })
        .then((res) => {});
      this.isloading = false;
    },
    approve() {
      this.approved = true;
      this.rejected = false;

      const payload = {
        id: this.userData._id,
        status: "ACTIVE",
      };
      this.$store.dispatch("tenant/updateKycStatusAction", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Kyc Status Approved",
          type: "success",
        });
        this.$refs.modal1.hide();
      });
    },
    reject() {
      this.approved = false;
      this.rejected = true;

      const payload = {
        id: this.userData._id,
        status: "REJECTED",
      };
      this.$store.dispatch("tenant/updateKycStatusAction", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Kyc Status Rejected",
          type: "success",
        });
        this.$refs.modal1.hide();
      });
    },
  },
  mounted: async function () {
    this.loading = true;
    this.selectedStatus = this.userData.status;
    this.viewManagemtDetail();
    // this.currentUser = this.userData;
    this.loading = false;
    //await this.$store.dispatch("tenant/viewUserManagementDetail", this.$route.params.userData._id)
  },
};
</script>

<style scoped>
.border-img-doc {
  border: 2px solid black;
  border-radius: 5px;
}
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: var(--primary) !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: var(--primary) !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}

.profile-left-menu {
  margin-top: 10px;
}
.profile-left-menu .profile-nav-menu {
  padding: 12px 12px;
  border-bottom: 1px solid #f2f2f2;
}
.profile-left-menu .active {
  color: #fff !important;
  background: var(--primary);
}

.update-bg-color {
  background-color: #403fe0;
  border: 1px solid #403fe0;
}
.cancel-border-clr {
  border: 1px solid #403fe0;
  background-color: #fff;
  color: #403fe0;
}
.cancel-border-clr span {
  font-weight: 500 !important;
}
.cancel-border-clr:hover {
  border: 1px solid #403fe0;
  background-color: #403fe0;
  color: #fff;
  font-weight: 400;
}

.profile-nav-menu i {
  line-height: 21px;
}

.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.modal-footer {
  justify-content: space-evenly;
}
.modal-header {
  background-color: var(--primary) !important;
}
.modal-title {
  margin-left: 0;
}
.tenantProfile_img img {
  width: -webkit-fill-available;
}
.line {
  border-left: 1px dashed #c2c2c2;
}
.line-bottom {
  border-bottom: 1px dashed #c2c2c2;
}

.user-info-card {
  border-radius: 16px;
  border: 1px solid #dee3ea;
}

.border-left-dashed {
  border-left: 1px dashed #c2c2c2;
}

.border-bottom-dashed {
  border-bottom: 1px dashed #c2c2c2;
}

.text-primary-custom {
  color: var(--primary);
}

.loading-container {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 767.98px) {
  .border-left-dashed {
    border-left: none;
    border-top: 1px dashed #c2c2c2;
    padding-top: 1rem;
    margin-top: 1rem;
  }

  .user-info-card {
    margin-bottom: 1rem;
  }
}
</style>
